import { Box, LinearProgress, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChartViewRoot = styled(Stack)({
  flex: 1,
  minHeight: 0,
});

/** Sizes the chart and is the positioning context of the refresh bar laid over its top edge. */
export const ChartCanvas = styled(Box)({
  position: 'relative',
  flex: 1,
  minHeight: 0,
});

export const RefreshProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.localOverlay,
}));
